export default __webpack_public_path__ + "static/media/a011-fsi-07.96d49a0b.svg";